// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const RecommendationStatus = props => {

    const displayClass = 'dot-icon-yellow';

    const msDay = 24 * 60 * 60 * 1000;

    const daysLeft = Math.floor((props.currentDate - props.recommendedDate) / msDay);

    return (
        <div className='recommended-days'>
            <span className={displayClass}/>
            <FormattedMessage
                id='DAYS_SINCE_RECOMMENDATION'
                values={{
                    days: daysLeft,
                    daysToDisplay: daysLeft
                }}
            />
        </div>
    );

};

RecommendationStatus.displayName = 'RecommendationStatus';
RecommendationStatus.propTypes = {
    currentDate: PropTypes.object.isRequired,
    recommendedDate: PropTypes.object.isRequired
};

export default RecommendationStatus;



// WEBPACK FOOTER //
// ./src/product/shared/components/recommendation-status.js